import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact-notes-dialig',
  templateUrl: './contact-notes-dialig.component.html',
  styleUrls: ['./contact-notes-dialig.component.scss']
})
export class ContactNotesDialigComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
